import { mergeObjectTypes } from '../cacheHelpers';

const CargoConsolidatedItemType = {
  merge: mergeObjectTypes
};

export default CargoConsolidatedItemType;
